import { cn } from '@/lib/cn';

/**
 * Bloc de squelette de chargement — un simple `div` pulsé, sans bibliothèque
 * externe (voir Sprint 7, cohérence des états de chargement). Composer
 * plusieurs `Skeleton` pour approximer la forme du contenu à venir (ligne de
 * texte, carte, avatar…) plutôt que d'afficher un texte "Chargement…" nu.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
